import { WorkerRequirementDomain } from "@clipboard-health/contract-worker-app-bff";
import { isDefined } from "@clipboard-health/util-ts";
import { generatePath, useHistory } from "react-router-dom";

import { WORKPLACE_DOCUMENTS_FULL_PATH } from "../../Documents/paths";
import { type PlacementDetail } from "../api/useGetPlacement";
import { useHiringQualificationRanking } from "../api/useHiringQualificationRanking";
import { usePlacementRecruiterScreeningConfig } from "../hooks/usePlacementRecruiterScreeningConfig";
import { shouldShowRequirement } from "../utils";
import { PlacementDocumentRequirementsCard } from "./PlacementDocumentRequirementsCard";
import { PlacementGroupedDocumentRequirementsCard } from "./PlacementGroupedDocumentRequirementsCard";

const GROUP_DOCUMENT_THRESHOLD = 3;

interface PlacementDocumentRequirementsCardsContainerProps {
  placementDetails: PlacementDetail;
}

export function PlacementDocumentRequirementsCardsContainer(
  props: PlacementDocumentRequirementsCardsContainerProps
) {
  const { placementDetails } = props;

  const history = useHistory();
  const { getHighestRankingQualification } = useHiringQualificationRanking();
  const { legacyDocumentRequirementId: legacyScreeningDocumentRequirementId } =
    usePlacementRecruiterScreeningConfig();

  const requiredDocuments = placementDetails.workerRequirements?.filter((requirement) =>
    shouldShowRequirement(requirement, legacyScreeningDocumentRequirementId)
  );

  const highestRankingSharedQualification = getHighestRankingQualification(
    placementDetails.workerTypes ?? []
  );

  const workplaceDocumentsPath = generatePath(WORKPLACE_DOCUMENTS_FULL_PATH, {
    workplaceId: placementDetails.workplace.id,
  });

  const requiredDocumentsCount = requiredDocuments?.length ?? 0;

  if (!isDefined(requiredDocuments) || requiredDocuments.length === 0) {
    return null;
  }

  if (requiredDocumentsCount >= GROUP_DOCUMENT_THRESHOLD) {
    const onClick = () => {
      history.push(
        `${workplaceDocumentsPath}?domain=${WorkerRequirementDomain.HIRING}&qualification=${highestRankingSharedQualification}`
      );
    };

    return (
      <PlacementGroupedDocumentRequirementsCard
        requiredDocumentsCount={requiredDocumentsCount}
        onClick={onClick}
      />
    );
  }

  return (
    <>
      {requiredDocuments.map((document) => (
        <PlacementDocumentRequirementsCard key={document.id} requirement={document} />
      ))}
    </>
  );
}
